import { contentfulClient } from "../services/contentful";
import { Entry } from "contentful";

export type JsonField = {
  id: string;
  key: string;
  value: string;
};

export interface IReportsFields {
  name?: string;
  looker?: boolean;
  slug?: string;
  dashboardId?: string;
  sheetId?: string;
  tabs?: JsonField[];
  menuOrder?: number;
  height?: string;
  customProps: JsonField[];
  showOnMenu?: boolean;
  featureFlag?: string;
}

export interface IReports extends Entry<IReportsFields> {
  sys: {
    id: string;
    type: string;
    createdAt: string;
    updatedAt: string;
    locale: string;
    contentType: {
      sys: {
        id: "reports";
        linkType: "ContentType";
        type: "Link";
      };
    };
  };
}

export const getReportBySlug = async (
  slug: string,
): Promise<IReports | null> => {
  const reportMenuItems = contentfulClient.getEntries({
    "fields.slug": slug,
    content_type: "reports",
    select: "fields",
  }) as Promise<{
    items: IReports[];
  }>;

  const response = await reportMenuItems;

  if (response.items.length) {
    return response.items[0];
  } else {
    return null;
  }
};

export const getReportsMenuItems = async () => {
  const reportMenuItems = contentfulClient.getEntries({
    content_type: "reports",
    select: "fields",
  }) as Promise<{
    items: IReports[];
  }>;

  const response = await reportMenuItems;
  return response.items.sort((a, b) => {
    const menuOrderA = a.fields.menuOrder || 0; // Use a default value of 0 if menuOrder is undefined
    const menuOrderB = b.fields.menuOrder || 0;

    return menuOrderA - menuOrderB;
  });
};
